export default __webpack_public_path__ + "static/media/beep-01.b769cffd.ogg";